import { makeAlertsContainer } from '../../../ui-lottery/src/containers/AlertsContainer';
import { clearAlerts } from '../actions/alerts';
import { alertsSel } from '../reducers';

const AlertsContainer = makeAlertsContainer(alertsSel, clearAlerts);

export default AlertsContainer;
